import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=2368a0ca&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=2368a0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368a0ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2368a0ca')) {
      api.createRecord('2368a0ca', component.options)
    } else {
      api.reload('2368a0ca', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=2368a0ca&scoped=true&", function () {
      api.rerender('2368a0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k9vtGYn280ac/JS/comp/DocBox.vue"
export default component.exports